<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-50" @close="$emit('close')">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 backdrop-blur-[2px] bg-[rgba(20,17,11,0.8)] lg:hidden"
          aria-hidden="true"
        />
      </TransitionChild>

      <!-- Sheet Container -->
      <div class="fixed inset-0">
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="translate-y-full"
          enter-to="-translate-y-0"
          leave="ease-in duration-200"
          leave-from="-translate-y-0"
          leave-to="translate-y-full"
        >
          <DialogPanel
            class="absolute bottom-0 flex h-auto max-h-[85vh] w-full flex-col bg-bg-canvas rounded-t-3xl lg:hidden"
          >
            <!-- Header -->
            <div
              class="flex h-[71px] shrink-0 items-center justify-between border-b border-outline-dividers px-4"
            >
              <slot name="header" />
            </div>

            <!-- Body -->
            <div class="flex-1 overflow-auto">
              <slot />
            </div>

            <!-- Footer -->
            <div v-if="$slots.footer" class="shrink-0 border-t border-outline-dividers px-4 py-3">
              <slot name="footer" />
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from "@headlessui/vue";

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["close"]);
</script>
